export { default } from './FeaturedProduct';
